// FastAPI's error `detail` can be a string, an object (custom handlers, e.g.
// rate limiting), or an array (Pydantic 422 validation errors — one entry per
// invalid field). Interpolating the object/array shapes straight into JSX
// throws "Objects are not valid as a React child" and crashes the page. This
// normalizes any shape into a single readable string.
export function messageFromDetail(err, fallback = 'Something went wrong.') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg).filter(Boolean).join('; ') || fallback;
  }
  if (detail?.msg) return detail.msg;
  return fallback;
}
